import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';


export interface SvgIconInfo {
  iconName: string;
  iconFilePath: string;
}

@Injectable({
  providedIn: 'root',
})
export class MatIconRegistryInitService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private iconSet: Map<string, SvgIconInfo> = new Map<string, SvgIconInfo>();

  init(iconInfos: SvgIconInfo[]): void {
    this.validateIconInfos(iconInfos);
    this.iconSet = new Map(iconInfos.map(icon => [icon.iconName, icon]));
    this.matIconRegistry.addSvgIconResolver((name) => {
      const svgIconInfo = this.iconSet.get(name);
      if (svgIconInfo) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/' + svgIconInfo.iconFilePath);
      }
      return null;
    });
  }

  private validateIconInfos(iconSet: SvgIconInfo[]) {
    const iconNames = new Set<string>(iconSet.map(icon => icon.iconName));
    if (iconNames.size !== iconSet.length) {
      throw new Error('Icon set contains duplicate icon names');
    }
  }
}
